(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  document.querySelectorAll('[data-reseller-spotlight]').forEach(section => {
    const targets = [...section.querySelectorAll('.luma-reseller-cta__logos-column,.luma-reseller-cta__globe')];
    let visible = false;
    const timers = new Set();
    const later = (callback, delay) => {
      const timer = setTimeout(() => { timers.delete(timer); callback(); }, delay);
      timers.add(timer);
    };
    const stop = () => {
      timers.forEach(clearTimeout); timers.clear();
      targets.forEach(target => target.classList.remove('is-random-glowing', 'is-chrome-shining'));
    };
    const pulse = target => {
      if (!visible || motion.matches || !target.isConnected) return;
      later(() => {
        const effect = target.matches('.luma-reseller-cta__logos-column') ? 'is-chrome-shining' : 'is-random-glowing';
        target.classList.add(effect);
        later(() => { target.classList.remove(effect); pulse(target); }, 2200);
      }, 4000 + Math.random() * 7000);
    };
    const start = () => { stop(); if (visible && !motion.matches) targets.forEach(pulse); };
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) start(); else stop();
    }).observe(section);
    motion.addEventListener('change', start);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
  });
})();
